"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.createUseRemoteComponent = void 0;
var react_1 = require("react");
var remote_module_loader_1 = __importDefault(require("@paciolan/remote-module-loader"));
var createUseRemoteComponent = function (args) {
    var loadRemoteModule = remote_module_loader_1["default"](args);
    var useRemoteComponent = function (url) {
        var _a = react_1.useState({
            loading: true,
            err: undefined,
            component: undefined
        }), _b = _a[0], loading = _b.loading, err = _b.err, component = _b.component, setState = _a[1];
        react_1.useEffect(function () {
            var update = setState;
            update({ loading: true, err: undefined, component: undefined });
            loadRemoteModule(url)
                .then(function (module) {
                return update({ loading: false, err: undefined, component: module["default"] });
            })["catch"](function (err) { return update({ loading: false, err: err, component: undefined }); });
            return function () {
                // invalidate update function for stale closures
                update = function () {
                    // this function is left intentionally blank
                };
            };
        }, [url]);
        return [loading, err, component];
    };
    return useRemoteComponent;
};
exports.createUseRemoteComponent = createUseRemoteComponent;
//# sourceMappingURL=useRemoteComponent.js.map